import { type AscProject } from '@neo.tax/asc/hooks';

export const LAUNCH_DATE_ERROR = 'Enter a valid date';

const COMPLETE_MASKED_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

const pad = (value: number): string => String(value).padStart(2, '0');

export const isCompleteMaskedDate = (value: string): boolean => COMPLETE_MASKED_DATE.test(value);

export const isRealMaskedDate = (value: string): boolean => {
  const match = COMPLETE_MASKED_DATE.exec(value);
  if (!match) {
    return false;
  }
  const [, month, day, year] = match;
  // `new Date` rolls Feb 30 forward to Mar 2, so the parts must round-trip.
  const date = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
  return (
    !Number.isNaN(date.getTime()) &&
    date.getUTCFullYear() === Number(year) &&
    date.getUTCMonth() + 1 === Number(month) &&
    date.getUTCDate() === Number(day)
  );
};

export const maskedDateToIsoDate = (value: string): string | null => {
  if (!isRealMaskedDate(value)) {
    return null;
  }
  const [, month, day, year] = COMPLETE_MASKED_DATE.exec(value) ?? [];
  return `${year}-${month}-${day}`;
};

// The scalar serializes the column as UTC midnight, so the day must be read in UTC.
export const isoDateToMaskedDate = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return `${pad(date.getUTCMonth() + 1)}/${pad(date.getUTCDate())}/${date.getUTCFullYear()}`;
};

export interface AscProjectMatchingForm {
  customFieldTeams: string[];
  launchDate: string;
}

export const makeDefaultFormValues = (
  ascProject: Pick<AscProject, 'customFieldTeams' | 'customFieldLaunchDate'>,
): AscProjectMatchingForm => ({
  customFieldTeams: ascProject.customFieldTeams ?? [],
  launchDate: isoDateToMaskedDate(ascProject.customFieldLaunchDate),
});
